import { alpha, Paper, Stack, Typography, Box } from "@mui/material";
import { ContactPhone } from "@mui/icons-material";
import { useMemo } from "react";
import { useGetUsersCommunicationsQuery } from "../../../store/services/communicationService";
import { AddCommunicationButton } from "./AddCommunicationButton";
import GroupedCommunications from "./GroupedCommunications";
import { LoadingState } from "./LoadingState";

interface CommunicationsProps {
  customerNo: number;
  isCompany?: boolean;
}

export const Communications = ({
  customerNo,
  isCompany = false,
}: CommunicationsProps) => {
  const {
    data: communications = [],
    isLoading,
    isError,
  } = useGetUsersCommunicationsQuery(customerNo);

  const sortedCommunications = useMemo(() => {
    return [...communications].sort((a, b) => {
      if (a.IsPrimary) return -1;
      if (b.IsPrimary) return 1;
      return 0;
    });
  }, [communications]);

  if (isLoading || isError) {
    return <LoadingState />;
  }

  return (
    <Box
      sx={sortedCommunications.length === 0 ?{
        position: "relative",
        borderRadius: "8px",
        p: "2px", // Border width
        background: "linear-gradient(60deg, #d32f2f, #f44336, #ef5350, #e57373, #d32f2f)",
        backgroundSize: "300% 300%",
        animation: "animatedGradient 3s ease infinite",
        
        "@keyframes animatedGradient": {
          "0%": {
            backgroundPosition: "0% 50%",
          },
          "50%": {
            backgroundPosition: "100% 50%",
          },
          "100%": {
            backgroundPosition: "0% 50%",
          },
        },
      }: undefined}
    >
      <Paper 
        sx={{ 
          p: 2,
          borderRadius: "6px", // Slightly smaller to show the border
          backgroundColor: "white",
          height: "100%",
        }}
      >
        <Stack
          direction="row"
          alignItems="center"
          justifyContent={"space-between"}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 1.25 }}>
            <Box
              sx={(theme) => ({
                width: 22,
                height: 22,
                borderRadius: "6px",
                bgcolor: alpha(theme.palette.primary.main, 0.1),
                color: theme.palette.primary.main,
                display: "grid",
                placeItems: "center",
                "& .MuiSvgIcon-root": { fontSize: 14 },
              })}
            >
              <ContactPhone />
            </Box>
            <Typography
              sx={{
                fontSize: 13,
                fontWeight: 700,
                textTransform: "uppercase",
                letterSpacing: ".08em",
                color: "#181614",
              }}
            >
              Kontaktvägar
            </Typography>
          </Box>
          <AddCommunicationButton isCompany={isCompany} customerNo={customerNo} />
        </Stack>

        <GroupedCommunications
          communications={sortedCommunications}
          customerNo={customerNo}
        />
      </Paper>
    </Box>
  );
};

export default Communications;